<template>
  <div>
    <div class="textF">{{ Text }}</div>
    <div class="valueF">{{ Value }}</div>
  </div>
</template>

<script>
export default {
  props: {
    Text: String,
    Value: String,
  },
};
</script>
<style scoped>
.textF {
  color: rgb(116, 116, 116);
  font-size: 0.9rem;
}
.valueF {
  color: #000;
  font-size: 1rem;
  padding: 1px 0px;
  font-weight:500;
}
</style>